import { FormComponent } from "@/components/base/form";
import { HorizontalContainer } from "@/components/layout/horizontal-container";
import { HorizontalSpacer } from "@/components/layout/horizontal-spacer";
import { PageContent } from "@/components/layout/page-content";
import { ButtonSkeleton } from "@/components/skeletons/button-skeleton";
import { HeadingSkeleton } from "@/components/skeletons/heading-skeleton";
import { RegisterButtonSkeleton } from "@/components/skeletons/register-button-skeleton";
import { TextSkeleton } from "@/components/skeletons/text-skeleton";
import { Loader } from "@/components/ui/loader";
import { Text } from "@/components/ui/text";

export function BliMedlemLoader() {
  return (
    <FormComponent>
      <PageContent width="x-small">
        <ButtonSkeleton />
      </PageContent>
      <HorizontalSpacer size="medium" />

      <PageContent width="large">
        <TextSkeleton size="small" />
        <HorizontalSpacer size="x-small" />
        <HeadingSkeleton type="h1" />
      </PageContent>

      <HorizontalContainer horizontalPlacement="center">
        <RegisterButtonSkeleton length={3} size="large" />
        <RegisterButtonSkeleton length={3} size="large" />
        <RegisterButtonSkeleton length={3} size="large" />
      </HorizontalContainer>
      <HorizontalSpacer />
    </FormComponent>
  );
}

export function ReceiptLoader() {
  return (
    <PageContent width="x-small">
      <Text
        value="Laster inn treningsglede! Dette tar bare et øyeblikk - ikke oppdater siden, vi gjør klart medlemskapet ditt."
        align="center"
      />
      <Loader />
    </PageContent>
  );
}
